export function scrollToElement(element: HTMLElement): void {
  let navigationScrollOffset = 120;
  if (window.innerWidth < 1200) {
    navigationScrollOffset = 68;
  }
  const scrollPosition = element.getBoundingClientRect().top + window.pageYOffset - navigationScrollOffset;

  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth',
  });
}

export function adjustScrollPadding() {
  const submenu = document.querySelector('.js-submenu');
  const anchorNavigation = document.querySelector('.js-anchorNav');
  if (submenu instanceof HTMLElement) {
    document.documentElement.classList.add('html--submenu');
  }
  if (anchorNavigation instanceof HTMLElement) {
    document.documentElement.classList.add('html--anchorNavigation');
  }
}
